import _ from 'lodash';
import collectionUtils from '../../../common/collection-utils';
import {GEO_TYPES} from '../../../../serp/constants';

require('!./innersvg-polyfill.js');

angular.module('cian.metroBrowser').controller('MetroSvgBrowserCtrl', [
  '$uibModalInstance',
  '$document',
  'ApiService',
  'FilterService',
  'FilterTermsService',
  'MetroService',
  'ScrollService',
  'RegionIds',
  'BrowserInfo',
  'regionId',
  'geo',
  // 'selectedStations',
  'footMin',
  'onlyFoot',
  'AnalyticsService',
  '$timeout',
  '$scope',
  function ($uibModalInstance,
            $document,
            ApiService,
            FilterService,
            FilterTermsService,
            MetroService,
            ScrollService,
            RegionIds,
            BrowserInfo,
            regionId,
            geo,
            footMin,
            onlyFoot,
            AnalyticsService,
            $timeout,
            $scope) {
    this.onlyFoot = onlyFoot;
    this.footMin = footMin;
    this.terms = FilterTermsService;
    this.isTouchDevice = BrowserInfo.isMobile || BrowserInfo.isTablet;

    let selectedStations = _.filter(geo.value, {type: GEO_TYPES.UNDERGROUND});

    const setStations = stations => {
      selectedStations = stations;
      collectionUtils.updateSubsetOfCollectionInPlace(
        geo.value,
        selectedStations,
        [GEO_TYPES.UNDERGROUND]
      );
    };

    // Обновляем фильтр сразу, когда меняется выбор станций
    $scope.$watchCollection(
      () => Object.keys(this.metroState.stations).filter(stationIsActive),
      (newVal, oldVal) => {
        if (newVal !== oldVal) setStations(newVal.map(stationId => {
          const station = this.metroData.stations[stationId];
          const id = Number(stationId);
          const text = station.name;
          const color = station.points[0].fill;

          return {
            id,
            text,
            color,
            type: GEO_TYPES.UNDERGROUND
          };
        }));
      }
    );

    this.defaultOnlyFootValue = MetroService.FOOT_MIN_DEFAULT;

    const stationIsActive = (id) => this.metroState.stations[id].isActive;

    this.save = ()=> {
      AnalyticsService.trackCA('Listing', 'popup_metro_save', String(selectedStations.length), {});
      $uibModalInstance.close();
    };

    this.toggleStations = (ids) => {
      const nextState = ids.every(stationIsActive) ? false : true;
      ids.forEach(id => {
        this.metroState.stations[id].isActive = nextState;
      });
    };

    this.isLoading = true;
    this.metroState = {
      lines: {},
      segments: {},
      stations: {}
    };

    const loadJson = (id, cb) => require.ensure([], () => cb(require(`@cian/metro/json/${id}.json`)));
    const drawMap = (metroData) => {
      this.lines = metroData.lines;
      this.changes = metroData.changes;
      this.stations = Object.values(metroData.stations);
      this.buttons = metroData.buttons;

      metroData.lines.forEach((line) => {
        this.metroState.lines[line.id] = {
          isHover: false,
        };

        line.segments.forEach((segment) => {
          this.metroState.segments[segment.id] = {
            isHover: false,
          };
        });
      });

      Object.values(metroData.stations).forEach((station) => {
        const selectedStationsObj = selectedStations.reduce((acc, item) => {
          acc[item.id] = true;
          return acc;
        }, {});

        this.metroState.stations[station.id] = {
          isHover: false,
          isActive: selectedStationsObj[station.id] || false
        };
      });

      this.metroData = metroData;
      $timeout(() => {
        this.isLoading = false;

        // Таймаут, чтобы контент отрисовался после ng-if: false -> true
        // и можно было определить его высоту
        $timeout(() => {
          const metroBrowserElement = $document[0].querySelector('.metro-browser');
          // Пользователь может очень быстро закрыть попап
          // и в таком случае metroBrowserElement будет null
          if (metroBrowserElement) {
            ScrollService.scrollInParentsCenter(metroBrowserElement);
          }
        });
      }, 0);
    };

    loadJson(regionId, drawMap);

    // Устанавливаем путь до метро по умолчанию (только для аренды)
    if (FilterService.dealTypeIs('rent') && this.onlyFoot.value === null) {
      $scope.$watch(() => this.metroState.stations, (newStations, oldStations) => {
        const newActiveStationsCount = _.filter(newStations, 'isActive').length;
        const oldActiveStationsCount = _.filter(oldStations, 'isActive').length;
        if (newActiveStationsCount > oldActiveStationsCount) {
          MetroService.updateFootValuesOnStationSelection(
            this.onlyFoot, this.footMin
          );
        }
      }, true);
    }
  }])
  .directive('svgFilterRestore', ['BrowserInfo', function (BrowserInfo) {
    return {
      link(scope, element, attrs) {
        /*
         IE 11 fix
         значение атрибута stdDeviation устанавливается в 1.68304e+009
         фиксим жестоко: сами ставим 2

         Safari fix
         блюр рендерится визуально менее заметным,
         поэтому приходится увеличивать размытие
         */
        const filter = element[0].getElementById('blur-filter');
        const blurElement = filter.querySelector('feGaussianBlur');
        blurElement.setAttribute(
          'stdDeviation',
          BrowserInfo.browserIs('Safari') ? '3' : '2'
        );
      }
    }
  }]);



// WEBPACK FOOTER //
// ./src/components/metro-browser/src/scripts/cian.metro-svg-browser.ctrl.js